<template>
	<v-card>
		<v-card-text>
			<v-row
				v-for="(lotteryResults, index) in lotteriesResults"
				:key="index"
				no-gutters
			>
				<v-col>
					<v-row v-if="!displayHorizontally" justify="center">
						<v-col cols="4">
							<v-img :src="imageUrl(lotteryResults.image.normal.url)" contain />
						</v-col>
					</v-row>
					<v-row no-gutters>
						<v-col v-if="displayHorizontally" cols="3" class="d-flex">
							<v-img
								:src="imageUrl(lotteryResults.image.normal.url)"
								contain
								class="align-self-center"
							/>
						</v-col>
						<v-col :cols="displayHorizontally ? 9 : 12">
							<v-row no-gutters>
								<v-col
									v-for="(sortitionResult, index) in lotteryResults.results"
									:key="index"
									cols="12"
								>
									<v-row no-gutters>
										<v-col>
											<v-row no-gutters>
												<v-col class="text-center">
													<p class="sortition-name">
														{{ sortitionResult.name }}:
														{{ sortitionResult.date }}
													</p>
												</v-col>
											</v-row>
											<v-row no-gutters>
												<v-col cols="2" class="text-center" align-self="center">
													<font-awesome-icon
														:icon="sortitionResult.icon"
													></font-awesome-icon>
												</v-col>
												<v-col cols="10">
													<v-row v-if="sortitionResult.numbers.length === 1">
														<v-col cols="10" class="text-center">
															<span
																v-for="(number, index) in sortitionResult
																	.numbers[0]"
																:key="index"
															>
																<img
																	class="small-ball"
																	:src="balls[parseInt(number)]"
																	:alt="number"
																/>
															</span>
														</v-col>
													</v-row>
													<v-row
														v-if="
															getAmountOfDigitsForResult(sortitionResult) <=
																7 && sortitionResult.numbers.length > 1
														"
														no-gutters
													>
														<v-col
															:cols="
																sortitionResult.numbers.length === 2 ? 5 : 4
															"
															class="text-center"
														>
															<span
																v-for="(number, index) in sortitionResult
																	.numbers[0]"
																:key="index"
															>
																<img
																	class="small-ball"
																	:src="balls[parseInt(number)]"
																	:alt="number"
																/>
															</span>
														</v-col>
														<v-col
															:cols="
																sortitionResult.numbers.length === 2 ? 7 : 4
															"
															class="text-center"
														>
															<span
																v-for="(number, index) in sortitionResult
																	.numbers[1]"
																:key="index"
															>
																<img
																	class="small-ball"
																	:src="balls[parseInt(number)]"
																	:alt="number"
																/>
															</span>
														</v-col>
														<v-col
															v-if="sortitionResult.numbers.length === 3"
															class="text-center"
															cols="4"
														>
															<span
																v-for="(number, index) in sortitionResult
																	.numbers[2]"
																:key="index"
															>
																<img
																	class="small-ball"
																	:src="balls[parseInt(number)]"
																	:alt="number"
																/>
															</span>
														</v-col>
													</v-row>
													<v-row
														v-if="
															getAmountOfDigitsForResult(sortitionResult) >=
																8 && sortitionResult.numbers.length > 1
														"
														no-gutters
													>
														<v-col :cols="5" class="text-center">
															<span
																v-for="(number, index) in sortitionResult
																	.numbers[0]"
																:key="index"
															>
																<img
																	class="small-ball"
																	:src="balls[parseInt(number)]"
																	:alt="number"
																/>
															</span>
														</v-col>
														<v-col :cols="7" class="text-center">
															<span v-if="index === 0">*</span>
															<span
																v-for="(number, index) in sortitionResult
																	.numbers[1]"
																:key="index"
															>
																<img
																	class="small-ball"
																	:src="balls[parseInt(number)]"
																	:alt="number"
																/>
															</span>
														</v-col>
														<v-col :cols="12" class="text-center">
															<span
																v-for="(number, index) in sortitionResult
																	.numbers[2]"
																:key="index"
															>
																<img
																	class="small-ball"
																	:src="balls[parseInt(number)]"
																	:alt="number"
																/>
															</span>
														</v-col>
													</v-row>
												</v-col>
											</v-row>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>
<script>
import fiery0 from './images/0.png';
import fiery1 from './images/1.png';
import fiery2 from './images/2.png';
import fiery3 from './images/3.png';
import fiery4 from './images/4.png';
import fiery5 from './images/5.png';
import fiery6 from './images/6.png';
import fiery7 from './images/7.png';
import fiery8 from './images/8.png';
import fiery9 from './images/9.png';

export default {
	name: 'ResultsCard',
	inject: ['contentStatus'],
	props: {
		resultsByLottery: {
			type: Object,
			required: true
		},
		displayHorizontally: {
			type: Boolean,
			required: false,
			default: false
		}
	},
	data() {
		return {
			balls: [
				fiery0,
				fiery1,
				fiery2,
				fiery3,
				fiery4,
				fiery5,
				fiery6,
				fiery7,
				fiery8,
				fiery9
			]
		};
	},
	computed: {
		lotteriesResults() {
			return Object.values(this.resultsByLottery);
		}
	},
	methods: {
		imageUrl(image) {
			return image;
		},
		getAmountOfDigitsForResult(result) {
			let counter = 0;
			result.numbers.forEach((n) => {
				counter += n.length;
			});
			return counter;
		}
	}
};
</script>

<style lang="scss">
.small-ball {
	max-height: 28px;
}

.sortition-name {
	font-size: 1.2rem;
}
</style>
